export default function FormStepper({ currentStep = 1 }) {
  const steps = [
    { label: 'Basic Information' },
    { label: 'Add Questions' },
    { label: 'Review' },
  ];

  return (
    <div className="mb-8">
      <ol className="flex items-center w-full p-4 gap-4 space-x-2 text-sm font-medium text-center text-gray-500 bg-white border border-gray-200 rounded-lg shadow-md dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700 sm:p-4 sm:space-x-4 rtl:space-x-reverse">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <li
              key={index}
              className={`flex items-center ${isActive ? 'text-blue-600 dark:text-blue-500' : ''}`}
            >
              <span
                className={`flex items-center justify-center w-5 h-5 me-2 text-xs border rounded-full shrink-0 ${
                  isActive
                    ? 'border-blue-600 dark:border-blue-500'
                    : 'border-gray-500 dark:border-gray-400'
                }`}
              >
                {stepNumber}
              </span>
              {step.label.split(' ')[0]}
              <span className="hidden sm:inline-flex sm:ms-2">{step.label.split(' ').slice(1).join(' ')}</span>
              {stepNumber !== steps.length && (
                <svg
                  className="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 12 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m7 9 4-4-4-4M1 9l4-4-4-4"
                  />
                </svg>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
